import { Box, Typography, Card, IconButton, Tooltip } from '@mui/material';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { colors } from '@src/styles';
import {
  cardTitleSX,
  fieldIconButtonSX,
  iconTileSX,
  monoFontFamily,
  profileCardSX,
  secretFieldSX,
} from '../profileStyles';

export type ProfileBearerCardProps = {
  onCopyBearer: () => void;
};

export const ProfileBearerCard = ({ onCopyBearer }: ProfileBearerCardProps) => {
  return (
    <Card elevation={0} sx={{ ...profileCardSX, gridColumn: { xs: '1', md: '1 / -1' }, padding: 2.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, marginBottom: 2 }}>
        <Box sx={iconTileSX}>
          <VpnKeyOutlinedIcon />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography component="h2" sx={cardTitleSX}>
            Bearer Token
          </Typography>
          <Typography sx={{ fontSize: '12.5px', color: colors.brand.textSecondary }}>
            Token da sua sessão atual. Ele nunca é exibido, só copiado.
          </Typography>
        </Box>
      </Box>
      <Box sx={secretFieldSX}>
        <Typography
          sx={{
            flex: 1,
            minWidth: 0,
            fontFamily: monoFontFamily,
            fontSize: '12.5px',
            color: colors.brand.textStrong,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {`${'•'.repeat(32)}`}
        </Typography>
        <Tooltip title="Copiar" arrow>
          <IconButton onClick={onCopyBearer} aria-label="Copiar bearer token" sx={fieldIconButtonSX}>
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Card>
  );
};
